import React, {useMemo} from 'react'
import Select from 'react-select'
import type {SingleValue, StylesConfig} from 'react-select'
import type {AssignedReporterOption} from './ticketReporterOptions'

type Props = {
  options: AssignedReporterOption[]
  value: string
  disabled?: boolean
  loading?: boolean
  onChange: (value: string) => void
}

const assignedReporterSelectStyles: StylesConfig<AssignedReporterOption, false> = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderColor: state.isFocused ? '#44d62c' : base.borderColor,
    boxShadow: state.isFocused ? '0 0 0 1px #44d62c' : 'none',
    '&:hover': {
      borderColor: '#44d62c',
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1060,
  }),
}

const AssignedReporterSelect: React.FC<Props> = ({
  options,
  value,
  disabled = false,
  loading = false,
  onChange,
}) => {
  const selectedOption = useMemo(() => {
    const normalizedValue = value.trim().toLowerCase()
    if (!normalizedValue) {
      return null
    }

    return options.find((option) => option.value.toLowerCase() === normalizedValue) ?? null
  }, [options, value])

  return (
    <Select<AssignedReporterOption, false>
      className='react-select-styled react-select-transparent'
      classNamePrefix='react-select'
      styles={assignedReporterSelectStyles}
      options={options}
      value={selectedOption}
      isSearchable
      isLoading={loading}
      isDisabled={disabled || loading}
      placeholder='Select assigned reporter'
      noOptionsMessage={() => (loading ? 'Loading users...' : 'No users found')}
      onChange={(selectedOption: SingleValue<AssignedReporterOption>) => onChange(selectedOption?.value ?? '')}
    />
  )
}

export {AssignedReporterSelect}
